interface FileFormatsStructure {
  [k: string]: {
    [key: string]: {
      mimeType: string
      extensions: string[]
    }
  }
}

export const FILE_FORMATS = {
  video: {
    mp4: {
      mimeType: 'video/mp4',
      extensions: ['.mp4'],
    },
    mpeg: {
      mimeType: 'video/mpeg',
      extensions: ['.mpeg', '.mpg'],
    },
    mov: {
      mimeType: 'video/quicktime',
      extensions: ['.mov'],
    },
  },
  image: {
    png: {
      mimeType: 'image/png',
      extensions: ['.png'],
    },
    jpeg: {
      mimeType: 'image/jpeg',
      extensions: ['.jpeg', '.jpg'],
    },
    gif: {
      mimeType: 'image/gif',
      extensions: ['.gif'],
    },
  },
  audio: {
    mp3: {
      mimeType: 'audio/mpeg',
      extensions: ['.mp3'],
    },
    wav: {
      mimeType: 'audio/wav',
      extensions: ['.wav'],
    },
    ogg: {
      mimeType: 'audio/ogg',
      extensions: ['.ogg'],
    },
  },
  document: {
    pdf: {
      mimeType: 'application/pdf',
      extensions: ['.pdf'],
    },
  },
  sheet: {
    csv: {
      mimeType: 'text/csv',
      extensions: ['.csv'],
    },
  },
} as const satisfies FileFormatsStructure
